export default "__VITE_ASSET__4fb2fe04__"